import React from 'react';
import { Link } from 'react-router-dom';


const Header = () => {
  return (
  <>
    <header className="gy-3">
      <nav className="navbar navbar-expand-lg navbar-light fixed-top py-3 backdrop" data-navbar-on-scroll="data-navbar-on-scroll">
        <div className="container">
          <Link className="navbar-brand d-flex align-items-center fw-bolder fs-2 fst-italic" to="/">
              <img src="/assets/images/logo.png" alt="Database" className="img-fluid w-15"/>
        </Link>
          <button className="navbar-toggler collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation"><span className="navbar-toggler-icon"></span></button>
          <div className="collapse navbar-collapse border-top border-lg-0 mt-4 mt-lg-0" id="navbarSupportedContent">
            <ul className="navbar-nav ms-auto pt-2 pt-lg-0">
              <li className="nav-item px-2"><Link className="nav-link fw-medium" aria-current="page" to="/" target="_blank" rel="noopener noreferrer">Home</Link></li>
              <li className="nav-item px-2"><Link className="nav-link fw-medium" to="/about/">About</Link></li>
              <li class="nav-item dropdown">
                  <a class="nav-link dropdown-toggle" href="#" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                    Tools
                  </a>
                  <ul class="dropdown-menu">
                    <li><Link className="nav-link fw-medium" to="/calculation/">Contacts calculation</Link></li>
                    <li><Link className="nav-link fw-medium" to="/pathfinder/">Pathfinder</Link></li>
                    <li><Link className="nav-link fw-medium" to="/projection/">Cross-species projection</Link></li>
                  </ul>
              </li>
              <li className="nav-item px-2"><Link className="nav-link fw-medium" to="/help/">Help</Link></li>
              <li className="nav-item px-2"><Link className="nav-link fw-medium" to="/glossary/">Glossary</Link></li>
              <li className="nav-item px-2"><Link className="nav-link fw-medium" to="/faq/">FAQs</Link></li>
              <li className="nav-item px-2"><Link className="nav-link fw-medium" to="/api/">API</Link></li>
              <li className="nav-item px-2"><Link className="nav-link fw-medium" to="/mcp/">MCP</Link></li>
              <li className="nav-item px-2 nobreak"><Link className="nav-link fw-medium" to="/log/">Release Log</Link></li>
              <li className="nav-item px-2"><Link className="nav-link fw-medium" to="https://bioinfolab.sns.it/" target="_blank" rel="noopener noreferrer">Bioinfolab</Link></li>
              <li className="nav-item px-2"><Link className="nav-link fw-medium" to="http://laboratoriobiologia.sns.it/" target="_blank" rel="noopener noreferrer">Bio@SNS</Link></li>
              <li className="nav-item px-2"><Link className="nav-link fw-medium" to="https://github.com/raimondilab/" target="_blank" rel="noopener noreferrer"><ion-icon name="logo-github"></ion-icon></Link></li>
            </ul>
          </div>
        </div>
      </nav>
    </header>
   </>
  );
}

export default Header;
